import { Button, SxProps, Theme, styled } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import StyledLoadingButton from './LoadingButton';

type ButtonProps = {
  onClick?: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  startIcon?: string;
  endIcon?: boolean;
  paddingX?: number;
  paddingY?: number;
  children: string;
  loading?: boolean;
  loadingText?: string;
  fontSize?: number;
};

const CommonButton = styled(Button)(({ disabled }) => ({
  borderRadius: 15,
  background: disabled
    ? 'var(--Accent-Light-Steel-Blue, #EEE) !important'
    : 'var(--Brand-Cadet-Blue, linear-gradient(138deg, #6599A5 24.11%, #3B667E 83.2%))',
  color: 'var(--Accent-White, #FFF) !important',
  '&:hover': {
    background: disabled
      ? 'var(--Accent-Light-Steel-Blue, #EEE) !important'
      : 'var(--Brand-Cadet-Blue, linear-gradient(138deg, #4e7c91 24.11%, #2d4f5f 83.2%))',
  },
}));

function StyledButton({
  onClick,
  disabled,
  fullWidth,
  startIcon,
  endIcon,
  children,
  paddingX,
  paddingY,
  loading,
  loadingText,
  fontSize,
}: ButtonProps) {
  if (!loading) {
    return (
      <CommonButton
        type="submit"
        color="primary"
        disabled={disabled}
        fullWidth={fullWidth}
        variant="contained"
        onClick={onClick}
        startIcon={startIcon ? <img src={startIcon} alt={startIcon} /> : null}
        endIcon={endIcon ? <ArrowForwardRoundedIcon /> : null}
        sx={{
          textTransform: 'none !important',
          padding: `${paddingY}px ${paddingX}px !important`,
          ...(fontSize && { fontSize }),
        }}
      >
        {children}
      </CommonButton>
    );
  }
  return (
    <StyledLoadingButton fullWidth={fullWidth} paddingY={paddingY} paddingX={paddingX}>
      {loadingText || children}
    </StyledLoadingButton>
  );
}

StyledButton.defaultProps = {
  paddingX: 32,
  paddingY: 16,
};

export default StyledButton;
